import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Spinner, Col, Row, Button, Alert } from 'react-bootstrap';

import { useStore } from '../../store';
import ReceptorTaxInfo from './info/ReceptorTaxInfo';
import Loading from '../../facturotopia/loading/Loading';
import PageHeader from '../../support/page-header/PageHeader';

class ReceptoresInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { id } = props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      data: !!data.id ? { ...data } : { id },
    };

    const { data: prev } = props.info;

    if (!prev.id || prev.id.toString() !== id) {
      props.infoActions.reset();
      props.infoActions.setPartialState(this.state);
    } else {
      this.state = {
        data: {
          ...prev,
        },
      };
    }
  }

  componentDidMount() {
    const { data } = this.state;

    if (!data.rfc) {
      this.props.history.replace('/app/receptores');
    }
  }

  render() {
    const { data = {}, busy } = this.props.info;
    const edit = {
      pathname: `/app/receptores/${data.id}/editar`,
      state: {
        data: { ...data },
      },
    };

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader
          text="Receptores"
          to="/app/receptores"
        />

        <h5>
          <Row>
            <Col>
              {!!busy && (
                <Spinner
                  animation="border"
                  role="status"
                  size="sm"
                  className="mr-3"
                >
                  <span className="sr-only">Recuperando información de receptor...</span>
                </Spinner>
              )}
              {data.rfc || '...'}
            </Col>

            {Guardian.allows('receptor.editar') && !data?.sector_primario_is_adquiriente && (
              <Col
                xs={2}
                className="text-right"
              >
                <Link
                  className="text-muted"
                  to={edit}
                >
                  <Button>Editar</Button>
                </Link>
              </Col>
            )}
          </Row>
        </h5>

        {!!data.rfc && (
          <div>
            {data?.sector_primario && data?.sector_primario_is_adquiriente && (
              <Alert variant="info">
                Este registro corresponde a un adquirente del sector primario. Para realizar modificaciones, por favor
                ingrese a la sección de emisores.
              </Alert>
            )}

            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <ReceptorTaxInfo data={data} />

            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Facturas</strong>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return { info: store.app.receptores.info };
};

const mapActions = (actions) => {
  return { infoActions: actions.app.receptores.info };
};

export default connect(useStore, mapState, mapActions)(ReceptoresInfo);
